import { useDogs } from "@/context/DogsContext";
import { Card, CardContent } from "@/components/ui/card";
import { PawPrint } from "lucide-react";

export default function EmptyDogState({ children }) {
  const { dogs } = useDogs();
  if (dogs.length) return children;
  return (
    <Card className="border-dashed border-border bg-card">
      <CardContent className="p-12 text-center">
        <div className="mx-auto h-12 w-12 rounded-md bg-muted flex items-center justify-center mb-4 text-muted-foreground">
          <PawPrint size={22} />
        </div>
        <h3 className="font-display text-2xl font-bold tracking-tight mb-2">Add your first dog</h3>
        <p className="text-sm text-muted-foreground max-w-md mx-auto">
          Click <strong>Add dog</strong> in the top right to create a profile and start tracking
          health, training, shows, and more.
        </p>
      </CardContent>
    </Card>
  );
}
